import { render } from "./DropdownDivider.vue?vue&type=template&id=b24d9c5e"
const script = {}

import exportComponent from "/srv/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__